import { render, staticRenderFns } from "./PageDownload.vue?vue&type=template&id=7b5dc930&scoped=true&"
import script from "./PageDownload.vue?vue&type=script&lang=js&"
export * from "./PageDownload.vue?vue&type=script&lang=js&"
import style0 from "./PageDownload.vue?vue&type=style&index=0&id=7b5dc930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5dc930",
  null
  
)

export default component.exports